
import ProgressBar from '@/components/ProgressBar.vue';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { VinculoPontoUnidade } from '../types-registro-ponto';

enum Status {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success'
}

@Component({
  components: {
    ProgressBar,
  },
})
export default class RegistroPontoSave extends Vue {
  //#region [ CONSTANTS ]
  readonly SUCCESS_TIMEOUT: number = 3000 as const;
  readonly ERROR_TIMEOUT: number = 15000 as const;
  //#endregion



  //#region [ DATA ]
  Status = Status;
  status: Status = Status.LOADING;
  errorMessage: string = '';
  progress: number = 0;
  backTimeout: number | null = null;
  vinculo: VinculoPontoUnidade | null = null;
  //#endregion



  //#region [ COMPUTED ]
  get description(): string {
    return ({
      [Status.LOADING]: 'Registrando ponto...',
      [Status.ERROR]: 'Erro ao salvar ponto!',
      [Status.SUCCESS]: 'Ponto salvo com sucesso!'
    } as Record<Status, string>)[this.status];
  }

  get progressBar(): ProgressBar {
    return this.$refs.progressBar as ProgressBar || null;
  }

  get progressBarColor(): string {
    return ({
      [Status.LOADING]: 'none',
      [Status.ERROR]: '#ff9994',
      [Status.SUCCESS]: '#94ff97'
    } as Record<Status, string>)[this.status];
  }

  get showProgressBar(): boolean {
    return this.status === Status.ERROR || this.status === Status.SUCCESS;
  }

  get nameVinculo(): string {
    return this.vinculo ? this.vinculo.NRNMVINCULO : '';
  }
  //#endregion



  //#region [ EVENTS ]
  @Emit('back')
  emitBack(): void {}
  //#endregion



  //#region [ LIFECYCLE ]
  created(): void {
    (window as any).setSaveStatus = {
      startLoading: this.startLoading.bind(this),
      error: this.error.bind(this),
      success: this.success.bind(this),
    };
  }

  beforeDestroy(): void {
    if (this.backTimeout) {
      window.clearTimeout(this.backTimeout);
    }
  }
  //#endregion



  //#region [ METHODS ]
  startBackCountdown(duration: number): void {
    if (this.backTimeout) {
      window.clearTimeout(this.backTimeout);
    }

    this.backTimeout = window.setTimeout(() => {
      this.emitBack();
    }, duration);
  }

  startLoading(vinculo: VinculoPontoUnidade = null): void {
    this.status = Status.LOADING;
    this.errorMessage = '';
    this.vinculo = vinculo;
    window.clearTimeout(this.backTimeout);
  }

  error(errorMessage: string): void {
    this.status = Status.ERROR;
    this.errorMessage = errorMessage;
    this.startBackCountdown(this.ERROR_TIMEOUT);
    this.progressBar.start(this.ERROR_TIMEOUT);
  }

  success(): void {
    this.status = Status.SUCCESS;
    this.errorMessage = '';
    this.startBackCountdown(this.SUCCESS_TIMEOUT);
    this.progressBar.start(this.SUCCESS_TIMEOUT);
  }
  //#endregion
}
